// extracted by mini-css-extract-plugin
module.exports = {"partner-text":"Partner_partner-text__61MTN","partner-imgs":"Partner_partner-imgs__38Wxt"};